import { type DropdownMenuContentProps, DropdownMenuLabel } from '@radix-ui/react-dropdown-menu';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { PRIORITIES } from '../-utils/config';

type Props = {
  children: React.ReactNode;
  currentPriority: string;
  onSelect: (priority: string) => void;
  popperContentProps?: DropdownMenuContentProps;
};

export const ChangePriorityDropdown = ({
  children,
  currentPriority,
  onSelect,
  popperContentProps,
}: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="w-40"
        side="bottom"
        align="end"
        {...popperContentProps}
      >
        <DropdownMenuLabel className="ml-2 text-xs leading-[25px] text-muted-foreground">
          Change priority
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="mx-1" />
        <DropdownMenuRadioGroup onValueChange={(value) => onSelect(value)} value={currentPriority}>
          {Object.values(PRIORITIES).map((priority) => {
            return (
              <DropdownMenuRadioItem
                key={priority.status}
                value={priority.status}
                disabled={currentPriority === priority.status}
              >
                <p className="mr-auto">{priority.label}</p>
                <priority.Icon size={18} />
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
